if (!customElements.get('mr-footer-newsletter')) {
  customElements.define('mr-footer-newsletter', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      const { signal } = this.controller;
      const feedback = this.querySelector('[data-mrf-feedback]');
      if (feedback) {
        const showFeedback = () => {
          if (!this.isConnected) return;
          feedback.focus({ preventScroll: true });
          feedback.scrollIntoView({ block: 'center', behavior: 'instant' });
        };
        showFeedback();
        window.addEventListener('load', showFeedback, { once: true, signal });
        window.addEventListener('pageshow', showFeedback, { signal });
      }
      const form = this.querySelector('form');
      const button = form?.querySelector('button');
      if (!button) return;
      const email = form.querySelector('input[type="email"]');
      const reset = () => {
        this.submitting = false;
        button.setAttribute('aria-busy', 'false');
        button.removeAttribute('aria-disabled');
        form.setAttribute('aria-busy', 'false');
        email.inert = false;
      };
      form.addEventListener('submit', () => {
        this.submitting = true;
        email.inert = true;
        button.setAttribute('aria-busy', 'true');
        button.setAttribute('aria-disabled', 'true');
        form.setAttribute('aria-busy', 'true');
      }, { signal });
      button.addEventListener('click', (event) => {
        if (this.submitting) event.preventDefault();
      }, { signal });
      form.addEventListener('invalid', reset, { capture: true, signal });
      window.addEventListener('pageshow', reset, { signal });
      reset();
    }

    disconnectedCallback() {
      this.controller?.abort();
    }
  });
}
